/* eslint-disable react/prefer-es6-class, react/prop-types */
import React from 'react';
import Localization from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export default React.createClass({
  displayName: 'SelfAssessmentQuizDirectionPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return Localization.t('quiz settings');
    },
  },

  /**
   * @params {String} quizDirection
   */
  _handleChange(quizDirection) {
    const attrs = {
      apps: {
        selfAssessment: {
          quizOptions: {
            quizDirection,
          },
        },
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  render() {
    const value = this.props.userSettings.apps.selfAssessment.quizOptions.quizDirection;
    return this._renderQuizDirectionOptions(value, this._handleChange);
  },
});
